import angular from 'angular';
import customColorChooserComponent from './customColorChooserComponent';

angular.module('sh.customColorChooser', []).component('shCustomColorChooser', customColorChooserComponent());
